import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { ExigeLogin, ExigePapel } from '@/auth/Guards'
import DashboardLayout from '@/layout/DashboardLayout'
import { Carregando } from '@/components/ui'

const LoginPage = lazy(() => import('@/auth/LoginPage'))
const CadastroPage = lazy(() => import('@/auth/CadastroPage'))
const MinhasAuditoriasPage = lazy(() => import('@/features/auditoria/MinhasAuditoriasPage'))
const DossiePage = lazy(() => import('@/features/auditoria/DossiePage'))
const RelatorioPage = lazy(() => import('@/features/relatorio/RelatorioPage'))
const FinalizacaoPage = lazy(() => import('@/features/relatorio/FinalizacaoPage'))
const FilaAprovacaoPage = lazy(() => import('@/features/gerente/FilaAprovacaoPage'))
const RevisaoPage = lazy(() => import('@/features/gerente/RevisaoPage'))
const FichasPage = lazy(() => import('@/features/admin/FichasPage'))
const FichaEditorPage = lazy(() => import('@/features/admin/FichaEditorPage'))
const CatalogoNCsPage = lazy(() => import('@/features/admin/CatalogoNCsPage'))
const UsuariosPage = lazy(() => import('@/features/admin/UsuariosPage'))
const PrestadorasPage = lazy(() => import('@/features/admin/PrestadorasPage'))
const AcervoMidiasPage = lazy(() => import('@/features/admin/AcervoMidiasPage'))
const AuditoriaPage = lazy(() => import('@/features/admin/AuditoriaPage'))
const GestaoNCsPage = lazy(() => import('@/features/ncs/GestaoNCsPage'))
const PainelInternoPage = lazy(() => import('@/features/dashboards/PainelInternoPage'))
const PainelPressaoPage = lazy(() => import('@/features/dashboards/PainelPressaoPage'))
const PainelPublicoPage = lazy(() => import('@/features/dashboards/PainelPublicoPage'))

export default function App() {
  return (
    <Suspense fallback={<Carregando altura={400} />}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/cadastro" element={<CadastroPage />} />

        {/* Painel público: rota sem autenticação, fora do layout do backoffice. */}
        <Route path="/publico" element={<PainelPublicoPage />} />

        <Route element={<ExigeLogin />}>
          <Route element={<DashboardLayout />}>
            <Route index element={<Navigate to="/auditorias" replace />} />
            <Route path="/auditorias" element={<MinhasAuditoriasPage />} />
            <Route path="/auditorias/:id" element={<DossiePage />} />
            <Route path="/auditorias/:id/relatorio" element={<RelatorioPage />} />
            <Route path="/auditorias/:id/finalizacao" element={<FinalizacaoPage />} />
            {/* Gestão consolidada de NCs — fiscal vê as dele, gerente/admin veem tudo (escopo no backend). */}
            <Route path="/ncs" element={<GestaoNCsPage />} />
            <Route path="/dashboard" element={<PainelInternoPage />} />
            {/* Painel de Pressão (Subsistema C) — leituras de pressão manométrica; escopo no backend. */}
            <Route path="/pressao" element={<PainelPressaoPage />} />

            <Route element={<ExigePapel papeis={['gerente', 'admin']} />}>
              <Route path="/aprovacoes" element={<FilaAprovacaoPage />} />
              <Route path="/aprovacoes/:id" element={<RevisaoPage />} />
            </Route>

            <Route element={<ExigePapel papeis={['admin']} />}>
              <Route path="/admin/fichas" element={<FichasPage />} />
              <Route path="/admin/fichas/:codigo" element={<FichaEditorPage />} />
              <Route path="/admin/ncs" element={<CatalogoNCsPage />} />
              <Route path="/admin/usuarios" element={<UsuariosPage />} />
              <Route path="/admin/prestadoras" element={<PrestadorasPage />} />
              <Route path="/admin/midias" element={<AcervoMidiasPage />} />
              <Route path="/admin/auditoria" element={<AuditoriaPage />} />
            </Route>
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/auditorias" replace />} />
      </Routes>
    </Suspense>
  )
}
